module.exports = __webpack_public_path__ + "static/img/5.ff57d9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/5.jpg
// module id = pAkR
// module chunks = 1